import {
  LEGACY_PRIVACY_LINKS,
  TRANSCEND_PRIVACY_LINKS,
  type PrivacyLinks,
} from '@/features/shared/constants/legalLinks'
import { useFeatureFlags } from '@/features/shared/services/FeatureFlags/useFeatureFlags'

/**
 * Returns the privacy link set resolved against the `transcend_privacy_updates`
 * feature flag. When the flag is ON, links point to the Transcend privacy
 * center; when OFF, they use the legacy shipt.com legal pages.
 */
export const usePrivacyLinks = (): PrivacyLinks => {
  const {
    flags: { transcend_privacy_updates },
  } = useFeatureFlags()
  return transcend_privacy_updates ? TRANSCEND_PRIVACY_LINKS : LEGACY_PRIVACY_LINKS
}
